/**
 * HUB-F — Onglets sections réparations.
 */
import React from 'react';
import { REPARATION_SECTIONS } from '../../utils/reparations/reparationsDisplay';

const SECTIONS = [
  { id: REPARATION_SECTIONS.OVERVIEW, label: "Vue d'ensemble" },
  { id: REPARATION_SECTIONS.EN_COURS, label: 'En cours' },
  { id: REPARATION_SECTIONS.ATTENTE_PIECE, label: 'Attente pièce' },
  { id: REPARATION_SECTIONS.TERMINE, label: 'Terminées / prêtes' },
  { id: REPARATION_SECTIONS.RECENT, label: 'Récentes' },
];

export default function ActiviteReparationsSectionTabs({ activeSection, onSectionChange, counts = {} }) {
  return (
    <div className="flex gap-2 flex-wrap" data-testid="activite-reparations-section-tabs">
      {SECTIONS.map((section) => {
        const isActive = activeSection === section.id;
        const count = counts[section.id];
        return (
          <button
            key={section.id}
            type="button"
            onClick={() => onSectionChange(section.id)}
            className={`px-4 py-2.5 min-h-[44px] rounded-xl text-sm font-semibold border ${
              isActive ? 'text-[var(--rm-white)]' : 'text-[var(--rm-gray-400)]'
            }`}
            style={{
              borderColor: isActive ? 'var(--rm-border-strong)' : 'var(--rm-border-subtle)',
              background: isActive ? 'var(--rm-bg-panel)' : 'transparent',
            }}
            data-testid={`activite-reparations-section-${section.id}`}
          >
            {section.label}
            {count != null && count > 0 && (
              <span className="ml-1.5 px-1.5 py-0.5 rounded-full text-xs rm-badge rm-badge--muted">{count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
